import { useState, useEffect } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, RefreshCw, Mail, Phone, Building2, Package } from "lucide-react";

export default function EnquiriesTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/enquiries").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e))).finally(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <p className="text-sm text-[#5A6B85]">{items.length} enquir{items.length === 1 ? "y" : "ies"} received through the website</p>
        <button
          data-testid="admin-enquiries-refresh"
          onClick={load}
          className="flex items-center gap-2 text-xs font-medium text-[#263562] border border-[#263562]/15 hover:border-[#3AB0E1] rounded-full px-4 py-2 transition-colors"
        >
          <RefreshCw className="w-3.5 h-3.5" /> Refresh
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center py-16">
          <Loader2 className="w-6 h-6 animate-spin text-[#3AB0E1]" />
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((q) => (
            <div key={q.id} data-testid={`admin-enquiry-row-${q.id}`} className="bg-white rounded-xl border border-[#263562]/10 p-5">
              <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
                <p className="font-semibold text-[#263562]">{q.name}</p>
                <span className="font-mono-tech text-[10px] uppercase tracking-[0.15em] text-[#949CA1]">
                  {new Date(q.created_at).toLocaleString()}
                </span>
              </div>
              <div className="flex flex-wrap gap-x-5 gap-y-1 text-xs text-[#5A6B85] mb-3">
                <span className="flex items-center gap-1.5"><Mail className="w-3 h-3 text-[#3AB0E1]" />{q.email}</span>
                {q.phone && <span className="flex items-center gap-1.5"><Phone className="w-3 h-3 text-[#3AB0E1]" />{q.phone}</span>}
                {q.business && <span className="flex items-center gap-1.5"><Building2 className="w-3 h-3 text-[#3AB0E1]" />{q.business}</span>}
                {q.product && (
                  <span className="flex items-center gap-1.5 font-medium text-[#263562]"><Package className="w-3 h-3 text-[#3AB0E1]" />{q.product}</span>
                )}
              </div>
              <p className="text-sm text-[#3D4E6E] font-light leading-relaxed">{q.message}</p>
            </div>
          ))}
          {items.length === 0 && (
            <p className="text-center text-sm text-[#949CA1] py-12">No enquiries yet.</p>
          )}
        </div>
      )}
    </div>
  );
}
